{
  "corporatePortal": {
    "userDetailsRows": {
      "selectUserAria": "Show user information"
    }
  }
}
